import React from 'react';
import CircularProgress from './CircularProgress';
const ComplianceMetrics = () => {
  // First row - Risk metrics
  const riskMetrics = [{
    id: 'offene-risiken',
    title: 'OFFENE RISIKEN',
    count: 1,
    subtitle: 'Risiken',
    icon: 'warning',
    iconColor: 'text-gray-500'
  }, {
    id: 'offene-medienberichte',
    title: 'OFFENE MEDIENBERICHTE',
    count: 0,
    subtitle: 'Berichte/Jahr',
    icon: 'document',
    iconColor: 'text-gray-500'
  }, {
    id: 'lieferanten-risiko',
    title: 'LIEFERANTEN MIT HOHEM RISIKO',
    count: 3,
    subtitle: 'Lieferanten',
    icon: 'alert',
    iconColor: 'text-green-500'
  }];
  // Circular progress indicators
  const progressMetrics = [{
    id: 1,
    title: 'ABSTRAKTE RISIKOANALYSE',
    percentage: 86.8,
    color: '#4CAF50',
    indicator: 'positive'
  }, {
    id: 2,
    title: 'CODE OF CONDUCT ABDECKUNG',
    percentage: 0,
    color: '#9E9E9E',
    indicator: 'neutral'
  }, {
    id: 3,
    title: 'ABDECKUNG SOZIALER AUSWIRKUNGEN (GRI 414-2)',
    percentage: 8.09,
    color: '#F44336',
    indicator: 'negative'
  }, {
    id: 4,
    title: 'UMWELTVERTRÄGLICHKEITSPRÜFUNG (GRI 308-2)',
    percentage: 6.6,
    color: '#F44336',
    indicator: 'negative'
  }, {
    id: 5,
    title: 'ISO 14001-ABDECKUNG',
    percentage: 8.51,
    color: '#4CAF50',
    indicator: 'positive'
  }, {
    id: 6,
    title: 'ISO 9001-ABDECKUNG',
    percentage: 0,
    color: '#9E9E9E',
    indicator: 'neutral'
  }, {
    id: 7,
    title: 'SA 8000 ABDECKUNG',
    percentage: 0,
    color: '#9E9E9E',
    indicator: 'neutral'
  }];
  return <div className="p-4" data-id="element-21">
      {/* Risk metrics row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-22">
        {riskMetrics.map(metric => <div key={metric.id} className="border rounded p-4" data-id="element-23">
            <div className="flex justify-between mb-2" data-id="element-24">
              <h3 className="text-xs font-semibold" data-id="element-25">{metric.title}</h3>
              <span className="text-xl font-bold" data-id="element-26">{metric.count}</span>
            </div>
            <div className="flex items-center text-xs text-gray-500" data-id="element-27">
              <span data-id="element-28">{metric.subtitle}</span>
              <div className={`ml-auto w-5 h-5 rounded-full border flex items-center justify-center ${metric.iconColor}`} data-id="element-29">
                {metric.icon === 'warning' && <span data-id="element-30">!</span>}
                {metric.icon === 'document' && <span data-id="element-31">D</span>}
                {metric.icon === 'alert' && <span data-id="element-32">•</span>}
              </div>
            </div>
          </div>)}
      </div>
      {/* Circular progress indicators */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-33">
        {progressMetrics.map(metric => <div key={metric.id} className="flex flex-col items-center justify-center p-4" data-id="element-34">
            <div className="relative" data-id="element-35">
              <CircularProgress percentage={metric.percentage} color={metric.color} size={100} data-id="element-36" />
              {metric.indicator === 'positive' && <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-green-500 rounded-full" data-id="element-37"></div>}
              {metric.indicator === 'negative' && <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-red-500 rounded-full" data-id="element-38"></div>}
              {metric.indicator === 'neutral' && <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-300 rounded-full" data-id="element-39"></div>}
            </div>
            <div className="mt-4 text-xs font-semibold text-center text-gray-700" data-id="element-40">
              {metric.title}
            </div>
          </div>)}
      </div>
    </div>;
};
export default ComplianceMetrics;